import React, { PureComponent, useState } from "react";
import { Chart } from "react-google-charts";
import { getCookie } from "../../services/Cookies";
import { ToastError } from "../../services/ToastMsg";
import { LOADING } from "../../action";
import { useDispatch } from "react-redux";
import axios from "axios";
export default function SingleChart(props) {
  const { chartData } = props;
  const dispatch = useDispatch();

  return (
    <div>
      <Chart className="LineChat1"
        width={'98%'}
        height={'300px'}
        chartType="LineChart"
        loader={<div>Loading Chart</div>}
        data={chartData}
        chartEvents={[
          {
            eventName: 'select',
            callback: ({ chartWrapper }) => {
              let chartWrapperLocal = chartWrapper;
              let chart = chartWrapper.getChart();
              let selection = chart.getSelection();
              ////console.log(selection,'selection');
              let [selectedItem] = selection;
              ////console.log(selectedItem);
              if (selectedItem) {
                ////console.log(selectedItem);
                let { row, column } = selectedItem;
                let dataTable = chartWrapper.getDataTable();
                if (row != null && typeof row != undefined) {
                  ////console.log(row);
                  //////
                  let rawData = dataTable.getValue(row, column + 1);
                  let sampleNumber = rawData.split("Sample No:")[1].trim();
                  const url =
                    process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Trend/file`;
                  dispatch({ type: LOADING, payload: true });
                  let token = getCookie("token");
                  let filedata = JSON.stringify({ fileName: sampleNumber });
                  let config = {
                    method: "post",
                    responseType: "blob",
                    url: url,
                    headers: {
                      Authorization: `Bearer ${token}`,
                      "Content-Type": "application/json",
                      Accept: "application/pdf"
                    },
                    data: filedata,
                  };
                  axios(config)
                    .then(async function (response) {
                      if (response.status == 200) {
                        dispatch({ type: LOADING, payload: false });
                        const file = new Blob([response.data], { type: "application/pdf" });
                        //Build a URL from the file
                        const fileURL = URL.createObjectURL(file);

                        window.open(fileURL, '_blank')
                        // window.location = fileURL;
                      } else {
                        ToastError(response.data.message);
                      }
                    })
                    .catch(function (error) {
                      dispatch({ type: LOADING, payload: false });
                      ////console.log(error);
                    });
                }
                else {
                  ToastError('No reports found. Please contact VPS admin');

                }
              }
            }
          }
        ]}
        options={{
          hAxis: {
             //title: '',
             //gridlines:{color: '#333', minSpacing: 60}
             format: 'M/d/yy',
           },
          legend: 'bottom',
          pointSize: 10,
          /*vAxis: {
            title: '',
            gridlines:{color: '#fff', minSpacing: 60}
          },*/
          series: {
            1: { curveType: 'function' },
          },
          interpolateNulls: true,
          tooltip: { isHtml: true, trigger: "visible" }
        }}
        rootProps={{ 'data-testid': '2' }}
      />
    </div>
  );
}
